import he from 'he';
import { DateFormate } from '../helpers/CommonHelpers';

export default function WebinarsContent({ hit, contRef, status }) {
  const contentItem = hit.source;
  return (
      <div className="webinar-event" ref={contRef}>
          <span className="webinar-event-flex">
            {contentItem.thumbUrl && (
                <div className="webinar-image">
                    {contentItem.thumbUrl && (
                        <img className="attachment-thumbnail-480 size-thumbnail-480" src={contentItem.thumbUrl} alt={contentItem.title} />
                    )}
                    {/* <button className="play">
                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14" fill="none">
                            <path d="M0 1.13402V12.866C0 13.7606 0.943322 14.3042 1.66979 13.8172L10.4958 7.95124C11.1681 7.50959 11.1681 6.49041 10.4958 6.03744L1.66979 0.182779C0.943322 -0.304165 0 0.239401 0 1.13402Z" fill="white"></path>
                        </svg>
                    </button> */}
                </div>
            )}
            <span>
                {/* <span class="directions-badge webinar primary">
                    <span class="directions-badge-icon">&nbsp;</span>
                    <span class="directions-badge-text">Webinar</span>
                </span> */}
                <a className="webinar-title reportTitle stretched-link" href={`${contentItem?.link ?? '/'}`}>{he.decode(contentItem?.title)}</a>
                <span className="webinar-description" dangerouslySetInnerHTML={{ __html: contentItem?.shortDescription }} />
            </span>
          </span>
          <span className="webinar-details">
              <span className="webinar-date">
                  <span className="date-info">{contentItem.date != null ? contentItem.date : DateFormate(contentItem.latestDate, 'MMMM d, yyyy')}</span>
                  {status === "upcoming" && (
                      <span>{`${contentItem.startTime} - ${contentItem.endTime} ${contentItem.timeZone != null ? contentItem.timeZone.label : ''}`}</span>
                  )}                    
              </span>
              {status === "upcoming" && (
                  <span className="webinar-actions">
                  <a href={`${contentItem?.link ?? '/'}`} target="_blank">Event Details</a>
                  <a className="register" href={contentItem.registerURL} target="_blank">Register</a>
              </span>
              )}                
          </span>
      </div>
  );
}